import React from 'react';
import { RiLogoutBoxLine } from 'react-icons/ri';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';

interface LogoutModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const LogoutModal = ({ isOpen, onClose, onConfirm }: LogoutModalProps) => {
  if (!isOpen) return null;

  return (
        <>
      <Modal
        backdrop="static"
        centered={true}
        toggle={onClose}
        isOpen={isOpen}
        className="rv-modal"
      >
        <ModalHeader className="w-100 justify-content-center p-13 position-relative rv-breadcrumb-border ">
          Logout
          <button
            type="button"
            className="close-button-currency position-absolute top-0 end-0 mt-1 me-3 border-0 bg-transparent fs-3"
            onClick={onClose}
          >
            &times;
          </button>
        </ModalHeader>
        <ModalBody className="fs-5 fw-bold text-center d-block">
          Are you sure you want to logout?
        </ModalBody>
        <ModalFooter className="d-flex justify-content-center align-items-center">
          <div className="d-flex flex-row gap-3">
            <Button
              className="btn-label rv-primary-btn rounded-1 px-1 ps-4 py-1 w-100 w-md-auto text-nowrap"
              onClick={onConfirm}
            >
              <i className="ri-logout-box-line ri-xl label-icon align-middle me-1"></i>
              {/* <RiPlayLargeLine size={16} /> */}
              <span className="ps-3 px-2 ms-2 me-1 modal-btn">{"Yes, Logout"}</span>
            </Button>
          </div>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default LogoutModal;